/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import * as Joi from 'joi-browser';
import qs from 'qs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Form from '../../../common/Form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { uuidv4 } from '../../../../../helpers/uuid';
import { getCryptedOrderDetailsURL } from '../../../utils/crypto';
import configENV from '../../../config';
import { isEmpty } from '../../../utils/object';
import {
    getFirstItemBillingZipCode,
    getOrderStatus,
    getFirstItemRecipientZipCode,
    getOrderConfirmationId,
} from '../../../../../../state/ducks/Checkout/Checkout-Selectors';
import { getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import { cartStatusCompleteList } from '../../../utils/featureSelectors';

const { PERSIST_KEY } = configENV;

class DesktopOrderByZipCode extends Form {
    state = {
        data: {
            orderNumber: '',
            zipCode: '',
            billingZipCode: '',
            recaptcha: '',
        },
        isSubmited: false,
        errors: {},
        replaceMask: {
            orderNumber: '*',
        },
        replaceMaskWith: {
            orderNumber: 'toUpperCase',
        },
    };

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
        }
    }

    verifyCallback=(recaptchaToken) => {
        this.setState({ captchaValue: recaptchaToken });
        if (recaptchaToken) {
            this.setState({ captchaError: '' });
        }
    }

    schema = {
        orderNumber: Joi.string()
            .trim()
            .regex(/^W?\d{8,30}$/i, 'order number format') // this regex will recieve order number with W or without min length 8 max is 30
            .min(8)
            .max(30)
            .required()
            .label('Order Number'),
        zipCode: Joi.string()
            .trim()
            .min(5)
            .max(10)
            .required()
            .label('Recipient Zip Code'),
        billingZipCode: Joi.string()
            .trim()
            .min(5)
            .max(10)
            .required()
            .label('Billing Zip Code'),
        recaptcha: Joi.string()
            .required()
            .label('Recaptcha'),
    };

    componentDidMount = () => {
        const { featureFlags } = this.props;
        // Remove recaptcha variable from form validation
        // if is-order-tracking-captcha-on flag is off
        if (!featureFlags['is-order-tracking-captcha-on']) {
            delete this.schema.recaptcha;
            delete this.state.data.recaptcha;
        }
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { data } = this.state;
        const { location } = this.props;
        if (location && location.search) {
            const params = qs.parse(location.search);
            if (params.orderStatusId && params.orderStatusId.match(/^[W]?\d+$/) && params.zipCode) {
                data.orderNumber = params.orderStatusId;
                data.zipCode = params.zipCode;
                this.setState({ data });
            }
        }
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const {
            isReadyState, error,
            callBack, history, orderDetails, uuid, ROSSOrder,
        } = props;
        const { isSubmited } = this.state;
        if (
            isReadyState && error && error.errorMessage && isSubmited
        ) {
            const { errors } = this.state;
            const billingZipError = error?.errorMessage?.includes('billing');
            if (billingZipError) {
                errors.billingZipCode = error.errorMessage;
            } else {
                errors.zipCode = error.errorMessage;
            }
        }
        /*
            It will redirect to path="/account/orders/uuid/order/zip"
            when the Submit button is clicked => `isSubmited` is true
        */
        if (
            isReadyState
          && isSubmited
          && callBack
          && callBack.url
          && (orderDetails || ROSSOrder)
          && ((orderDetails && !isEmpty(orderDetails[uuid])) || (ROSSOrder && !isEmpty(ROSSOrder)))
          && callBack.url !== this.props.location.pathname
        ) {
            history.push(callBack.url);
        }
    };

    componentDidMount() {
        this.preFillOrderDetails();
    }

    preFillOrderDetails = () => {
        const {
            orderStatus, zipCode, orderConfirmationId, getBillingZipCode,
        } = this.props;
        if (orderStatus && cartStatusCompleteList.includes(orderStatus)) {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    zipCode,
                    orderNumber: orderConfirmationId,
                    billingZipCode: getBillingZipCode,
                },
            }));
        }
    }

    doSubmit = (submitData) => {
        const { featureFlags, ssrDeviceType } = this.props;
        const data = { ...this.state.data };
        const { zipCode, billingZipCode } = data;
        const uuid = uuidv4();
        data.uuid = uuid;
        const url = getCryptedOrderDetailsURL(data.orderNumber, uuid, zipCode, billingZipCode) || '';
        data.featureFlags = featureFlags;
        data.callBack = { url };
        // Adding payload ssrDeviceType: desktop | mobile
        data.ssrDeviceType = ssrDeviceType;
        this.setState({ isSubmited: true }, () => {
            submitData.handleSubmitOrderByZipCode(data);
        });
    };

    render() {
        /* eslint-disable max-len */
        const { isReadyState, featureFlags, handleSubmitOrderByZipCode } = this.props;
        const submitData = { handleSubmitOrderByZipCode };

        return (
            <div className="trackOrderContainer">
                <h2 className="subHeader">Track by order # without signing in</h2>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    disabled={!isReadyState}
                >
                    {this.renderInput({
                        name: 'orderNumber',
                        label: 'Order #',
                        type: 'text',
                        pattern: '^[wW0-9]*$',
                        length: 30,
                        minLength: 8,
                        desktop: true,
                    })}
                    {this.renderInput({
                        name: 'zipCode',
                        label: 'Recipient Zip Code',
                        type: 'text',
                        pattern: '^[a-zA-Z\\s\\-0-9]*$',
                        length: 10,
                        desktop: true,
                    })}
                    {this.renderInput({
                        name: 'billingZipCode',
                        label: 'Billing Zip Code',
                        type: 'text',
                        pattern: '^[a-zA-Z\\s\\-0-9]*$',
                        length: 10,
                        desktop: true,
                    })}
                    {featureFlags['is-order-tracking-captcha-on'] && (
                        <div className="captchaContainer">
                            {this.renderRecaptcha('recaptcha')}
                        </div>
                    )}
                    <div className="margin-top-2x opacity1">
                        {this.renderButton({
                            label: 'Submit',
                            className: 'submitBtn',
                            type: 'submit',
                            isValidated: false,
                        })}
                    </div>
                </form>
            </div>

        );
    }
}

DesktopOrderByZipCode.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    handleSubmitOrderByZipCode: PropTypes.func,
    orderStatus: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    orderConfirmationId: PropTypes.string.isRequired,
    featureFlags: PropTypes.object.isRequired,
    ssrDeviceType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        toggleState: newState.toggleState,
        error: newState.error,
        orderStatus: getOrderStatus(state),
        zipCode: getFirstItemRecipientZipCode(state),
        orderConfirmationId: getOrderConfirmationId(state),
        getBillingZipCode: getFirstItemBillingZipCode(state),
        ssrDeviceType: getSSRDeviceType(state),
        callBack: newState.callBack,
        orderDetails: newState.orderDetails,
        ROSSOrder: newState.ROSSOrder,
        uuid: newState.uuid,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitOrderByZipCode: (data) => dispatch(EventDispatcher.handleSubmitOrderByZipCode(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopOrderByZipCode));
